// eslint-disable-next-line jira/restricted/react
import React, { PureComponent } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import CompassCrossFlowTouchPoint from '@atlassian/jira-compass-cross-flow/src/ui/index.tsx';
import { CrossFlowProvider } from '@atlassian/jira-cross-flow/src/services/index.tsx';

type Props = {
	isCompassLicensed: boolean;
	origin: string;
	onCrossFlowComplete?: () => void;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CrossFlowTouchPointWrapper = styled.div({
	marginTop: token('space.200'),
	marginRight: 0,
	marginBottom: token('space.200'),
	marginLeft: 0,
});

// eslint-disable-next-line jira/react/no-class-components
class CompassCrossFlow extends PureComponent<Props> {
	static defaultProps: Partial<Props> = {
		isCompassLicensed: false,
	};

	render() {
		const { isCompassLicensed, origin, onCrossFlowComplete } = this.props;

		return (
			!isCompassLicensed && (
				<CrossFlowProvider>
					<CrossFlowTouchPointWrapper>
						<CompassCrossFlowTouchPoint
							origin={origin}
							eventSource="jiraComponentsSection"
							onCrossFlowComplete={onCrossFlowComplete}
						/>
					</CrossFlowTouchPointWrapper>
				</CrossFlowProvider>
			)
		);
	}
}

export default CompassCrossFlow;
